<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('resellers.edit')"
  :rightActions="rightActions"
)
  UiFormGroup(
    :label="$t('resellers.name')"
    :vuelidateModel="v$.form.name"
  )
    UiInput#name-input(
      v-model="form.name"
      :error="v$.form.name.$error"
    )
  UiFormGroup(
    :label="$t('resellers.email')"
    :vuelidateModel="v$.form.email"
  )
    UiInput#email-input(
      v-model="form.email"
      :error="v$.form.email.$error"
    )
</template>

<script>
import ApiResellers from "@/api/resellers";
import useVuelidate from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
      },
    };
  },

  data() {
    return {
      show: false,
      isInvite: false,
      resellerId: null,
      form: {},
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    open(resellerId, resellerUser) {
      this.v$.$reset();
      if (resellerUser) {
        this.isInvite = false;
        this.form = {
          id: resellerUser.id,
          name: resellerUser.name,
          email: resellerUser.email,
        };
      } else {
        this.isInvite = true;
        this.form = {
          name: "",
          email: "",
        };
      }
      this.resellerId = resellerId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      this.v$.$validate().then((res) => {
        if (!res) return;
        const form = this.form;
        const params = {
          name: form.name,
          email: form.email,
        };
        const resellerId = this.resellerId;
        if (this.isInvite) {
          ApiResellers.inviteResellerUser(resellerId, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        } else {
          ApiResellers.updateResellerUser(resellerId, form.id, params)
            .then((res) => {
              this.$emit("done");
              this.close();
            })
            .catch((e) => {});
        }
      });
    },
  },
};
</script>
